import { Calendar } from '@/components/Calendar';
import { Lazbubu } from '@/gql/graph/__generated__/request';
import { useAdventures } from '@/hooks/useAdventures';
import moment from 'moment';
import { useEffect, useState } from 'react';

export default function Adventure({ lazbubu }: { lazbubu: Lazbubu }) {
    const { adventures, getAdventures } = useAdventures(lazbubu.tokenId);
    const [expanded, setExpanded] = useState(false);
    const [date, setDate] = useState<Date | undefined>(new Date());

    useEffect(() => {
        getAdventures(date);
    }, [date]);

    return (
        <div className="w-full pb-[160px]">
            <div className="flex items-center justify-between">
                <div className="text-[20px] font-semibold">Journey</div>
                <Calendar date={date} setDate={setDate} />
            </div>
            {adventures.length > 0 ? (
                <>
                    {adventures
                        .slice(0, expanded ? adventures.length : 2)
                        .map((adventure) => (
                            <div
                                key={adventure.txHash}
                                className="mt-[20px] text-[12px] bg-white border border-border rounded-[16px] px-[20px] py-[10px]"
                            >
                                <div className="text-gray">
                                    {moment(adventure.timestamp * 1000).format(
                                        'hh:mm A',
                                    )}
                                </div>
                                <div className="mt-[10px]">
                                    {adventure.text}
                                </div>
                            </div>
                        ))}
                    {adventures.length > 2 && (
                        <button
                            className="text-[12px] text-primary px-[20px] py-[10px] rounded-[12px] border border-border bg-white mt-[20px]"
                            onClick={() => setExpanded(!expanded)}
                        >
                            {expanded ? 'Collapse' : 'Expand more'}
                        </button>
                    )}
                </>
            ) : (
                <div className="text-center py-[40px]">No journey</div>
            )}
            <div className="text-[20px] font-semibold mt-[40px]">Photos</div>
            {adventures.filter((adventure) => !!adventure.image).length > 0 ? (
                <div className="flex gap-[20px] mt-[20px]">
                    {adventures
                        .filter((adventure) => !!adventure.image)
                        .map((adventure) => (
                            <img
                                key={adventure.txHash}
                                src={adventure.image}
                                alt="adventure"
                                className="w-[200px] h-[200px] rounded-[32px]"
                            />
                        ))}
                </div>
            ) : (
                <div className="py-[40px] text-center">No photos</div>
            )}
        </div>
    );
}
